import { render } from "./transfer-history.vue?vue&type=template&id=49793068&scoped=true"
import script from "./transfer-history.vue?vue&type=script&lang=js"
export * from "./transfer-history.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-49793068"

export default script